import React, {useContext} from 'react';
import {Divider, Dropdown, Form, Grid, Header} from 'semantic-ui-react';

import {DictionaryContext} from 'Common/DictionaryContext';

export default ({
  countries,
  formObject,
  updateField,
  showSaveCard,
  processorName,
}) => {
  const dictionary = useContext(DictionaryContext);
  return (
    <div>
      <Divider style={{margin: '25px 0'}} />

      <Header as="h2">Billing Address</Header>

      <Grid>
        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.firstName && formObject.firstName.error}
            label="First Name"
            onChange={(e, {value}) => updateField(value, 'firstName')}
            required
            value={(formObject.firstName && formObject.firstName.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.lastName && formObject.lastName.error}
            label="Last Name"
            onChange={(e, {value}) => updateField(value, 'lastName')}
            required
            value={(formObject.lastName && formObject.lastName.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.address1 && formObject.address1.error}
            label="Address 1"
            onChange={(e, {value}) => updateField(value, 'address1')}
            required={formObject.address1 && formObject.address1.isRequired}
            value={(formObject.address1 && formObject.address1.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            label="Address 2"
            onChange={(e, {value}) => updateField(value, 'address2')}
            value={(formObject.address2 && formObject.address2.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.city && formObject.city.error}
            label="City"
            onChange={(e, {value}) => updateField(value, 'city')}
            required={formObject.city && formObject.city.isRequired}
            value={(formObject.city && formObject.city.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.state && formObject.state.error}
            label={formObject.countryId.value === 'US' ? 'State' : 'Province'}
            onChange={(e, {value}) => updateField(value, 'state')}
            required={formObject.state && formObject.state.isRequired}
            value={(formObject.state && formObject.state.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Field
            required={formObject.countryId && formObject.countryId.isRequired}
          >
            <label>Country</label>

            <Dropdown
              fluid
              loading={countries.loading}
              noResultsMessage="No Countries to display."
              onChange={(e, {value}) => updateField(value, 'countryId')}
              options={countries.data.map(e => ({
                text: e.country,
                value: e.countryId,
              }))}
              placeholder="Country"
              search
              selection
              value={formObject.countryId.value}
            />
          </Form.Field>
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.zip && formObject.zip.error}
            label={
              formObject.countryId.value === 'US' ? 'Postal Code' : 'Zip Code'
            }
            onChange={(e, {value}) => updateField(value, 'zip')}
            required={formObject.zip && formObject.zip.isRequired}
            value={(formObject.zip && formObject.zip.value) || ''}
          />
        </Grid.Column>

        <Grid.Column computer={8} mobile={16} tablet={8}>
          <Form.Input
            error={formObject.email && formObject.email.error}
            label="Email Address"
            onChange={(e, {value}) => updateField(value, 'email')}
            required={formObject.email && formObject.email.isRequired}
            value={(formObject.email && formObject.email.value) || ''}
          />
        </Grid.Column>

        {showSaveCard && (
          <Grid.Column computer={8} mobile={16} tablet={8}>
            <Form.Field>
              <label>&nbsp;</label>
              <Form.Checkbox
                checked={
                  (formObject.saveCard && formObject.saveCard.value) || false
                }
                label={
                  <label>
                    <strong>Save card on file</strong>&nbsp; (You must obtain
                    verbal consent from your{' '}
                    {dictionary
                      ? dictionary.CustomerName.value.toLowerCase()
                      : 'customer'}{' '}
                    to store card details with {processorName} before
                    proceeding.)
                  </label>
                }
                onChange={(e, {checked}) => updateField(checked, 'saveCard')}
              />
              <span />
            </Form.Field>
          </Grid.Column>
        )}
      </Grid>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Payments/PaymentCollection/components/PaymentForm/AddressForm.js